import React, { useContext } from 'react'
import styles from './styles.module.css'
import CloseIcon from '@mui/icons-material/Close';
import { Grid, IconButton } from '@mui/material';
import DataTable from 'components/utils/DataTable';
import { useTranslation } from 'react-i18next';
import ShopsHelper from 'helpers/ShopsHelper';
import { ShopContext } from 'Context/ShopContext';

function ProductionDetailsDialog({ production, handleClose }) {
    const { t: tCommon } = useTranslation("common");
    const { shop } = useContext(ShopContext);

    const summary = production?.config?.raw_materials?.reduce((acc, item) => {
        acc.totalCost += item.totalCost || 0;
        return acc;
    }, { totalCost: 0 }) || { totalCost: 0 };

    const listHeader = [
        { label: tCommon("Item Name"), id: 'name', type: 'text' },
        { label: tCommon("Quantity"), id: 'quantity', type: 'text' },
    ];

    const rawMaterialsHeader = [
        {
            label: tCommon('Item Name'),
            id: 'name',
            type: 'text',
        },
        {
            label: tCommon('Quantity'),
            id: 'quantity',
            type: 'callback',
            viewRender: (item) => parseFloat(item.quantity.toFixed(3)),
        },
        {
            label: tCommon("Cost"),
            id: 'cost',
            type: 'text',
        },
        {
            label: tCommon("Total Cost"),
            id: 'totalCost',
            type: 'callback',
            viewRender: (item) => ShopsHelper.getAmountFormatted(shop, item.totalCost),
        },
    ];

    return (
        <div className={styles.popUp}>
            <div className={styles.contentWrapper}>
                <div className={styles.headSec}>
                    <h2 className={styles.editTitle}>{tCommon("Production Details")}</h2>
                    <IconButton aria-label="close" onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={styles.detailsWrapper}>
                    <Grid container spacing={2} style={{ padding: '16px' }}>
                        <Grid item xs={12} sm={6} md={4}>
                            <h3 className={styles.tableContent1}>{tCommon("Production ID")}</h3>
                            <h3 className={styles.customerData}>{production?.id}</h3>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <h3 className={styles.tableContent1}>{tCommon("Created By")}</h3>
                            <h3 className={styles.customerData}>{production?.created_by?.username || '-'}</h3>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <h3 className={styles.tableContent1}>{tCommon("Date")}</h3>
                            <h3 className={styles.customerData}>{production?.created_at || '-'}</h3>
                        </Grid>
                    </Grid>
                    <div className={styles.tableContent1}>
                        <DataTable
                            columns={listHeader}
                            rows={production?.items}
                        />
                    </div>
                    <div className={styles.tableContent1}><span>Raw Materials</span></div>
                    <div className={styles.tableContent1}>
                        <DataTable
                            columns={rawMaterialsHeader}
                            rows={production?.config?.raw_materials}
                            summary={{
                                name: tCommon('Total'),
                                totalCost: `${shop?.currency || ''} ${summary.totalCost}`,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductionDetailsDialog